import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import {
    FETCH_USER_DATA_REQUEST,
    FETCH_USER_ACTION_FAIL,
    fetchUserActionFail,
    fetchUserActionSuccess,
    fetchPnbHeaderActionSuccess,
    uploadToImpactSuccess,
    uploadToImpactFailure,
} from '../../actions/pnbActions/pnsActions';
import { fetchAllUsers, fetchUsersByPid } from '@src/apps/ProviderBriefing/ProviderBriefingDocument/Main/main.service';
import {
  FETCH_PNB_HEADER_DATA,
  SET_PROVIDER_PROFILE_DATA,
  SET_CURRENT_STATE_DATA,
  SET_PNB_STRATEGY_DATA,
  SET_PNB_DOC_UPDATE_TYPE,
  UPLOAD_TO_IMPACT_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {fetchHeaderData, uploadDocToImpact} from '@src/middleware/services/pnb/pnb.service';



// Worker saga: Handles the API call
function* fetchPnsStrategySaga(action: any) {
  try {


    // Get the current updateType directly from Redux state
    const refreshValue = sessionStorage.getItem('pnb_refresh_value');
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const pid = url.searchParams.get('pid'); // Extract 'pid' parameter
    let response;
    if (pid && refreshValue !== "all" && refreshValue !== "unedited") {
      sessionStorage.setItem('pnb_refresh_value', '');
      response = yield call(fetchUsersByPid, pid);
    } else {
      sessionStorage.setItem('pnb_refresh_value', '');
    // Check if documentId exists in sessionStorage
    const  documentId = sessionStorage.getItem('documentId');


    // Fetch all users
    response = yield call(fetchAllUsers);

    // Add documentId to response if it exists
    if (documentId && response) {
      response.documentId = documentId;

    }
    }

    if (response) {
      yield put(fetchUserActionSuccess(response));
    }

  } catch (error: any) {
    // Store only serializable error fields in Redux (never the raw AxiosError,
    // which contains non-serializable references like request/config/promises).
    const serializableError = {
      status: error?.response?.status ?? error?.status ?? null,
      message: error?.message ?? 'Something went wrong',
      code: error?.code ?? null,
    };
    yield put(fetchUserActionFail(serializableError));
  }
}



function* fetchPnbHeaderSaga(action: any) {
  try {
    const pid = new URL(window.location.href).searchParams.get('pid');
    let response;
    if(!pid){
      response = yield call(fetchHeaderData);
    }
    if (response) {
      yield put(fetchPnbHeaderActionSuccess(response));
    }
  } catch (error) {
    console.error('Error:PNB', error);
  }
}

function* uploadToImpactSaga(action: any) {
  try {
    const response = yield call(uploadDocToImpact, action.payload);
    if (response) {
      yield put(uploadToImpactSuccess());
    } else {
      yield put(uploadToImpactFailure());
    }
  } catch (error) {
    console.error('Error uploading to Impact:', error);
    yield put(uploadToImpactFailure());
  }
}

export function* pnsStrategySaga() {
    // Watch for the fetch user request
    yield takeEvery(FETCH_USER_DATA_REQUEST, fetchPnsStrategySaga);
    yield takeEvery(UPLOAD_TO_IMPACT_REQUEST, uploadToImpactSaga);
}

export default [pnsStrategySaga];